export default "__VITE_ASSET__BflMa3MN__"